import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Divider from 'material-ui/Divider';

class TitleBar extends Component {
  static propTypes = {
    title: PropTypes.string
  }
  render() {
    return (<div className="row">
      <div className="col s12">
        <div className="row">
          <div className="col s12 center-align">
            <h4 className="pageTitle">{this.props.title}</h4>
          </div>
        </div>
        <div className="row">
          <div className="col s12"><Divider /></div>
        </div>
      </div>
    </div>);
  }
}

export default TitleBar;


// WEBPACK FOOTER //
// ./src/components/TitleBar/index.js